import { orderVideoFiles } from '@core/video/videoElementWrapper/utils/video';
import { roundRobinCDN } from './roundRobinCDN';
export { roundRobinCDN };
/**
 * Converts an aspect ratio string to a numeric array.
 * @param aspectRatio - The aspect ratio string to convert.
 * @returns An array of two numbers representing the width and height of the aspect ratio.
 */
export function aspectRatioToNumber(aspectRatio) {
    if (typeof aspectRatio === 'string') {
        const [width, height] = aspectRatio.split(':').map(Number);
        return width / height;
    }
    return aspectRatio;
}
/**
 * Returns first jpeg poster from `video_posters`. Item typically provided
 * by user as a custom poster. Other auto-generated posters are not jpeg (gif and webp).
 */
export function getVideoPosterJpg(video) {
    return video?.video_posters?.find((poster) => poster.format === 'jpg')?.url;
}
/**
 * Returns first jpeg poster from `video_posters` with the closest aspect ratio.
 */
export function getVideoPosterJpgByAspectRatio(video, aspectRatio) {
    const aspectRatioNumber = aspectRatioToNumber(aspectRatio);
    return (video?.video_posters?.find((poster) => poster.format === 'jpg' &&
        (!aspectRatio ||
            (aspectRatioNumber >= 1
                ? aspectRatioToNumber(poster.aspect_ratio) >= 1
                : aspectRatioToNumber(poster.aspect_ratio) < 1)))?.url || '');
}
/**
 * Returns the placeholder's blurhash for the first suitable video file from `video_files`.
 */
export function getVideoBlurhash(video) {
    const orderedVideoFiles = video ? orderVideoFiles(video, []) : [];
    return orderedVideoFiles[0]?.placeholder_blur_hash || '';
}
/**
 * Returns the placeholder url for the first suitable video file from `video_files`. Note
 * the placeholder is a first frame of the video.
 */
export function getVideoPlaceholder(video, preferredCDNs) {
    const orderedVideoFiles = video ? orderVideoFiles(video, preferredCDNs) : [];
    return orderedVideoFiles[0]?.placeholder_url || '';
}
/**
 * Returns first `jpg` poster from `video_posters` or `thumbnail_url`
 * if none found. This helper is legacy and does not take placeholder into
 * account.
 */
export function getVideoPoster(video, preferredCDNs) {
    return roundRobinCDN(getVideoPosterJpg(video) || video?.thumbnail_url || '', preferredCDNs);
}
/**
 * Gets a video's poster by type
 * @param video a video with video_posters
 * @param type the type to search for
 * @param format the image format to search for
 */
export const getVideoPosterByType = (video, type, format) => video?.video_posters.find((poster) => poster.video_poster_type === type &&
    (format ? poster.format === format : true));
